import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useInteractionMenuStyle = makeStyles({
	cleanButtonSize: {
		minWidth: 0,
		...shorthands.padding(0),
	},
	menuPopover: {
		overflowY: "hidden",
		overflowX: "hidden",
		zIndex: 102,
	},
	menuButton: {
		width: "2rem",
		height: "2rem",
	},
	menuButtonSpacing: {
		marginRight: "15px",
	},
	filterCheckboxItem: {
		">:first-child": {
			order: 3,
		},
	},
	popoverContent: {
		minWidth: "11.25rem",
	},
	popoverContentZIndex: {
		zIndex: 102,
	},
	queueFilterPopoverContent: {
		minWidth: "17rem",
		maxHeight: "24rem",
		overflowY: "scroll",
		overflowX: "hidden",
		marginTop: ".6rem",
		marginBottom: ".6rem",
	},
	filterGroupHeader: {
		display: "flex",
		justifyContent: "space-between",
	},
	supervisorButtonColor: {
		color: tokens.colorBrandBackground,
	},
	customPaddingButton: {
		paddingLeft: "11px",
		paddingRight: "11px",
		minWidth: "77px",
	},
	searchInput: {
		margin: "0px",
		marginLeft: "2px",
		border: "none",
		width: "100%",
		"& input": {
			width: "100%",
		},
	},
	filterTypeButton: {
		minWidth: "0px",
		padding: "3px",
	},
});
